import highlight from './highlight';
import lowlight from 'lowlight/lib/core';
var SyntaxHighlighter = highlight(lowlight, {});
SyntaxHighlighter.registerLanguage = lowlight.registerLanguage;
export default SyntaxHighlighter;


//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/react-syntax-highlighter/dist/esm/light.js
// module id = 1347
// module chunks = 0